var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_513_4544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_513_4544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.42295V2.03833H12.5V5.42295H11.5ZM16.9962 7.71143L16.3135 7.02873L18.6712 4.57681L19.3981 5.3095L16.9962 7.71143ZM18.5769 12.4999V11.4999H21.9616V12.4999H18.5769ZM11.5 21.9614V18.596H12.5V21.9614H11.5ZM7.0423 7.68063L4.57693 5.3287L5.32885 4.621L7.73078 7.00371L7.0423 7.68063ZM18.6654 19.4229L16.3135 16.971L16.9904 16.3133L19.3789 18.6595L18.6654 19.4229ZM2.03845 12.4999V11.4999H5.42308V12.4999H2.03845ZM5.30963 19.423L4.62115 18.671L6.97885 16.3133L7.33845 16.6614L7.7173 17.0153L5.30963 19.423ZM12.0045 16.9999C10.6169 16.9999 9.43589 16.5142 8.46153 15.5429C7.48718 14.5715 7 13.392 7 12.0044C7 10.6168 7.48567 9.43577 8.457 8.4614C9.42835 7.48705 10.6078 6.99988 11.9955 6.99988C13.3831 6.99988 14.5641 7.48555 15.5385 8.45688C16.5128 9.42823 17 10.6077 17 11.9954C17 13.383 16.5143 14.564 15.543 15.5384C14.5717 16.5127 13.3922 16.9999 12.0045 16.9999ZM12 15.9999C13.1 15.9999 14.0417 15.6082 14.825 14.8249C15.6083 14.0415 16 13.0999 16 11.9999C16 10.8999 15.6083 9.95821 14.825 9.17488C14.0417 8.39155 13.1 7.99988 12 7.99988C10.9 7.99988 9.95834 8.39155 9.175 9.17488C8.39167 9.95821 8 10.8999 8 11.9999C8 13.0999 8.39167 14.0415 9.175 14.8249C9.95834 15.6082 10.9 15.9999 12 15.9999Z",
    fill: "#3A5F77"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.f399de569227b2e1911a4a065ad5dddf.svg";
export { ForwardRef as ReactComponent };